/* eslint-disable no-restricted-syntax */

import Immutable from 'immutable';
import { SET_QUALIFICATION_ENROLMENTS } from './actions';
import { UPDATE_ENROLLED_CLASS_DATA } from '../Auth/actions';
import { QUALIFICATION_ENROLMENT_SUCCESS } from '../Portal/actions';

const initialState = Immutable.Map();

/**
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */
export function QualificationEnrolments(state = initialState, action = {}) {
  const addQualificationEnrolment = (qualification, newState) => {
    const keyPath = [
      'byInstitution',
      qualification.get('portal'),
      qualification.get('mongo_id'),
    ];
    if (!newState.hasIn(keyPath)) {
      return newState.setIn(keyPath, Immutable.Map({ qualification }));
    }
    return newState;
  };

  switch (action.type) {
    case UPDATE_ENROLLED_CLASS_DATA:
    case SET_QUALIFICATION_ENROLMENTS: {
      const { qualificationEnrolments } = action;
      let newState = state;
      for (const qualificationEnrolment of qualificationEnrolments) {
        const qualification = Immutable.fromJS(
          qualificationEnrolment.qualification
        );
        newState = addQualificationEnrolment(qualification, newState);
      }
      return newState;
    }
    case QUALIFICATION_ENROLMENT_SUCCESS: {
      let { qualification } = action;

      // need to remap courses to just the urls
      qualification = qualification.update('coreCourses', (v) =>
        v.map((course) => course.get('path'))
      );
      qualification = qualification.update('electiveCourses', (v) =>
        v.map((course) => course.get('path'))
      );

      return addQualificationEnrolment(qualification, state);
    }
    default: {
      return state;
    }
  }
}
